<template>
  <v-layout
    align-center
    justify-end
    wrap
    :justify-center="$vuetify.breakpoint.xs"
  >
    <v-flex
      shrink
      :mr-4="$vuetify.breakpoint.smAndUp"
      order-xs2
      order-sm1
      :mt-2="$vuetify.breakpoint.xs"
    >
      <router-link
        :to="{ name: 'family-welcome-info' }"
        class="link_iconed"
      >
        <v-icon>chevron_left</v-icon>
        {{ $t('buttons.prev_button') }}
      </router-link>
    </v-flex>
    <v-flex
      shrink
      order-xs1
      order-sm2
    >
      <v-btn
        color="sz_violet"
        class="ml-4"
        :disabled="crzLoader"
        @click="validateData()"
      >
        {{ $t('buttons.next_button') }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'FamilyReporterButtons',
    inject: ['$validator'],
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        crzLoader () {
            return this.$store.getters['crz/getCrzLoader'];
        }
    },
    methods: {
        validateData () {
            this.$emit('validate');
        }
    }
};
</script>

<style scoped></style>
